import styled from 'styled-components';
import Heading from '../Heading';
const H1 = styled(Heading).withConfig({
  displayName: "H1",
  componentId: "hyg7zz-0"
})([""]);
H1.propTypes = Heading.propTypes;

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
H1.defaultProps = Object.assign({}, Heading.defaultProps, {
  tagName: 'h1'
});
H1.displayName = 'H1';
export default H1;